import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { ArrowLeft, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminFounding() {
  const [members, setMembers] = useState([]);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("jenova_admin_token")) {
      navigate("/admin/login");
      return;
    }
    Promise.all([
      api.get("/admin/founding").then((r) => r.data),
      api.get("/founding/status").then((r) => r.data),
    ])
      .then(([m, s]) => {
        setMembers(m);
        setStatus(s);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="pt-24 md:pt-28 pb-24 min-h-screen bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="border-b border-[#E5E2DC] pb-6">
          <Link to="/admin" className="text-sm text-stone-500 hover:text-[#1A1C1A] inline-flex items-center gap-1 mb-2">
            <ArrowLeft strokeWidth={1.5} className="w-4 h-4" /> Back to Products
          </Link>
          <p className="text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold">Studio</p>
          <h1 className="mt-2 font-serif text-4xl md:text-5xl font-light tracking-tight">
            Founding <em className="italic text-stone-600">members</em>.
          </h1>
          {status && (
            <div className="mt-4 flex items-center gap-3 text-sm">
              <Users strokeWidth={1.5} className="w-4 h-4 text-stone-500" />
              <span className="text-stone-700">
                <strong className="text-[#1A1C1A]">{status.claimed}</strong> of {status.total_slots} spots claimed
              </span>
              <span className="text-stone-400">·</span>
              <span className="text-stone-500">{status.spots_left} left</span>
            </div>
          )}
        </div>

        <div className="mt-8 bg-white border border-[#E5E2DC] rounded-xl overflow-hidden">
          <div className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-[#E5E2DC] bg-[#F9F9F6] text-xs uppercase tracking-[0.2em] font-semibold text-stone-500">
            <div className="col-span-1">#</div>
            <div className="col-span-3">Email</div>
            <div className="col-span-2">Name</div>
            <div className="col-span-2">Instagram</div>
            <div className="col-span-3">Code</div>
            <div className="col-span-1">Joined</div>
          </div>
          {loading && <div className="p-8 text-center text-stone-500">Loading…</div>}
          {!loading && members.length === 0 && (
            <div className="p-12 text-center text-stone-500 font-serif italic">
              No founding members yet. Share the homepage!
            </div>
          )}
          {members.map((m) => (
            <div key={m.id} className="grid grid-cols-12 gap-4 px-6 py-4 border-b border-[#E5E2DC] items-center hover:bg-[#F9F9F6] transition-colors text-sm">
              <div className="col-span-1 font-serif text-lg">#{m.spot_number}</div>
              <div className="col-span-3 truncate">{m.email}</div>
              <div className="col-span-2 truncate">{m.name || "—"}</div>
              <div className="col-span-2 truncate text-stone-500">{m.instagram || "—"}</div>
              <div className="col-span-3 font-mono text-xs tracking-wide">{m.discount_code}</div>
              <div className="col-span-1 text-xs text-stone-500">{new Date(m.created_at).toLocaleDateString()}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
